import { Directive, ElementRef, Input, HostListener } from '@angular/core';

import { FileUploader } from '../classes/file-uploader.class';

// todo: filters

@Directive({ selector: '[ng2FileSelect]' })
export class FileSelectDirective {
    @Input() public uploader: FileUploader;
   
    private element: ElementRef;
    public constructor(element: ElementRef) {
        this.element = element;
    }

    public getOptions(): any {
        return this.uploader.options;
    }

    public getFilters(): any {
        return void 0;
    }

    public isEmptyAfterSelection(): boolean {
        return !!this.element.nativeElement.attributes.multiple;
    }

    @HostListener('change')
    public onChange(): any {

        let files = this.element.nativeElement.files;
        let options = this.getOptions();
        let filters = this.getFilters();
      //Notify
        this.uploader.fileSelected.emit(files);

        // when upload only one file clear last file and we take latest file only 
        if (!this.element.nativeElement.multiple)
            this.uploader.clearQueue();

        //Add to Queue
        // check if uploader has files or not
        if (files.length > 0)
            //Add to Queue
            this.uploader.addToQueue(files, options, filters);

        else if (files.length == 0)
            this.uploader.clearQueue();

        // check if element have multiple upload or not
        // check if file lengths equals zero to cancel it
        if (this.element.nativeElement.multiple || files.length == 0)
            //Reset element
            this.element.nativeElement.value = "";

          
        this.checkValidExtention();
    }

    checkValidExtention() {
        let files = this.element.nativeElement.files;
        if (this.getOptions()) {
            let allowedTypes = this.getOptions().allowedFileType.split(",");
            let vaildExtention = true;
            for (let i = 0; i < files.length; i++) {
               // console.log("file", files[i])
                let ex = /[^.]+$/.exec(files[i]["name"])[0];
                //console.log("ex", ex)
                if (allowedTypes[0] != "" && !allowedTypes.includes(ex))
                    vaildExtention = false;
            }
         this.uploader.vaild = vaildExtention;
        }
       

    }

}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/fileUpload/directives/file-select.directive.ts